import axios from 'axios';
import { captureException } from '@sentry/browser';
import mixpanel from 'Utils/mixpanel';

import {
  SENTRY_IGNORE_STATUS_CODES,
  SENTRY_IGNORE_DATA_CODES
} from 'Store/constants/sportTypes';

export const handleAxiosErrors = () => {
  // handle errors that might occur on request phase
  axios.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    captureException(error);
    return Promise.reject(error);
  });

  // handle response errors which might be an invalid JSON body etc. from an api
  axios.interceptors.response.use(response => response, error => {
    mixpanel.track('Get Request Failed', {
      'Request Name': error?.response?.request?.responseURL,
      'Request Result': error?.response?.data,
      'Request Result Code': error?.response?.data?.code || error?.response?.status,
    });
    
    if (SENTRY_IGNORE_DATA_CODES.includes(error?.response?.data?.code)) {
      return Promise.reject(error);
    }

    if (SENTRY_IGNORE_STATUS_CODES.includes(error?.response?.status)) {
      return Promise.reject(error);
    }

    const errorInfo = {
      url: error.config?.url,
      method: error.config?.method?.toUpperCase(),
      status: error.response?.status,
      statusText: error.response?.statusText,
      responseData: error.response?.data,
      requestData: error.config?.data
    };

    captureException(error, {
      tags: {
        errorType: 'API_ERROR',
        endpoint: errorInfo.url?.split('?')[0],
        httpMethod: errorInfo.method,
        statusCode: String(errorInfo.status),
        apiCode: String(error.response?.data?.code || 'N/A')
      },
      extra: errorInfo,
      level: 'error'
    });
    
    return Promise.reject(error);
  });
};
export const logError = error => {
  captureException(error);
};
